import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { TypeOfProblemModel } from '../model/masters/typeOfProblem.model';
import { ZoneModel } from '../model/masters/zone.model';
import { ResponeBookingDetails } from '../model/FormsEntity/ResponeMessage';
import { HousingScheme } from '../model/masters/housingScheme.model';
import { ResponseMessage } from '../model/FormsEntity/responseForOnlineBooking';
import { RWAOfficeSpaceEnt } from '../model/FormsEntity/RwaOfficeSpaceEnt';
import { ArchitectureDepartmentModel } from '../model/FormsEntity/architectureDepartmentModel';
import { EngineeringDepartmentModel } from '../model/FormsEntity/engineeringDepartmentModel';
import { HorticultureDepartmentModel } from '../model/FormsEntity/horticultureDepartmentModel';
import { ApprovalDepartmentModel } from '../model/FormsEntity/approvalDepartmentModel';
import { RwaDeficiencyMemoModel } from '../model/FormsEntity/rwaDeficiencyMemoModel';
import { RWARegistrationEnt } from '../model/FormsEntity/RwaRegistrationEnt';
import { ObjectionerRwaRegisModel } from '../model/FormsEntity/objectionerRwaRegisModel';
import { RWAMeetingScheduleModel } from '../model/FormsEntity/rWAMeetingScheduleModel';
import { environment } from '../../environments/environment';
@Injectable({providedIn: 'root'})
  
  export class RWAService {
    private usersUrl: string;
    private usersUrl1: string;
    private disputeUrl: string;
    private workFlowURL: string;
    private rwaRegistrationWorkFlow: string;
    private rwaDespute:string;
    private rwaMaintenanceWf:string;
    
    constructor(private http:HttpClient) {
        this.disputeUrl = environment.wflowUrl + 'rwa/dispute/workflow/';
       this.usersUrl = environment.baseUrl + 'masterData/';
       this.usersUrl1 = environment.baseUrl + 'rwa/';
       this.workFlowURL = environment.wflowUrl + 'rwa/workflow/';
       this.rwaRegistrationWorkFlow = environment.wflowUrl + 'rwa/registration/workflow/';
       this.rwaDespute = environment.wflowUrl + 'rwa/dispute/workflow/';
       this.rwaMaintenanceWf = environment.wflowUrl + 'rwa/rwaMaintenance/workflow/';
    
    }
    public getTypeOfProblemList(value){
        return this.http.get<TypeOfProblemModel>(this.usersUrl +'getTypeOfProblemList');
    }
    public getHousingSchemeList(value){
        return this.http.get<HousingScheme>(this.usersUrl +'getHousingSchemeList');
    }
      public getZoneList(value){
          return this.http.get<ZoneModel>(this.usersUrl +'getZoneList');
    }
    public getRWAOfficeSpaceForm(){
        return this.http.get<RWAOfficeSpaceEnt>(this.usersUrl1 +'listRWAOfficeSpaceForm');
    }
    public getRWAOfficeSpaceFormById(userId){
        return this.http.get<RWAOfficeSpaceEnt>(this.usersUrl1 +'listRWAOfficeSpaceForm/'+userId);
    }
    // public submitRWAMaintainance(rwaMaintainance){
      
    //     return this.http.post<ResponseMessage>(this.usersUrl1 +'submitRWAMaintainance',rwaMaintainance);
       
    // }
    public submitRWAMaintainance(rwaMaintainance){
       
        // let d={
            
        //     'statusCode':rwaMaintainance.statusCode,
        //     'createdById':rwaMaintainance.createdById,
        //     'firstName': rwaMaintainance.firstName,
        //     'lastName': rwaMaintainance.lastName,
        //     'mobileNo': rwaMaintainance.mobileNo,
        //     'emailId' : rwaMaintainance.emailId,
        //     'buildingName': rwaMaintainance.buildingName,
        //     'city': rwaMaintainance.city,
        //     'dateOccured': rwaMaintainance.dateOccured,
        //     'description': rwaMaintainance.description,
        //     'flatNo': rwaMaintainance.flatNo,
        //     'housingScheme': rwaMaintainance.housingScheme,
        //     'maintenanceFile': rwaMaintainance.maintenanceFile,
        //     'pinCode': rwaMaintainance.pinCode,
        //     'problemCaused': rwaMaintainance.problemCaused,
        //     'rwaadditemDetailsList': rwaMaintainance.rwaadditemDetailsList,
        //     'sector': rwaMaintainance.sector,
        //     'societyName': rwaMaintainance.societyName,
        //     'typeofProblem': rwaMaintainance.typeofProblem,
        //     'zone': rwaMaintainance.zone,
        //     'pk': rwaMaintainance.pk,
            
        //    }
        let header = new HttpHeaders();
        header= header.append('content-type', 'application/json');
        console.log(rwaMaintainance);
         return this.http.post<ResponseMessage>(this.usersUrl1 +'submitRWAMaintainance',rwaMaintainance);//d,{headers : header}
        
     }
    public submitRWARegistration(rwaRegistration){
        return this.http.post<ResponseMessage>(this.usersUrl1 +'submitRWARegistration',rwaRegistration);
    }
    public submitRWAOfficeSpace(rwaOfficeSpace){
        return this.http.post<any>(this.usersUrl1 +'submitRWAOfficeSpace',rwaOfficeSpace);
    }
    public saveArchitectureQuery(architectureQuery){
        return this.http.post<any>(this.workFlowURL +'rwaDepartmentApproval',architectureQuery);
    }
    public saveHorticultureQuery(horticultureQuery){
        return this.http.post<ResponseMessage>(this.usersUrl1 +'saveHorticultureQuery',horticultureQuery);
    }
    public saveEngineeringQuery(engineeringQuery){
        return this.http.post<ResponseMessage>(this.usersUrl1 +'saveEngineeringQuery',engineeringQuery);
    }
    public getRWAOfficeSpaceAsoArchForm(id){
        return this.http.get<ApprovalDepartmentModel>(this.usersUrl1 +'listRWAOfficeSpaceArchQueryForm/'+id);
    }
    public getRWAOfficeSpaceAsoEnggForm(id){
        return this.http.get<EngineeringDepartmentModel>(this.usersUrl1 +'listRWAOfficeSpaceEnggQueryForm/'+id);
    }
    public getRWAOfficeSpaceAsoHortiForm(id){
        return this.http.get<HorticultureDepartmentModel>(this.usersUrl1 +'listRWAOfficeSpaceHortiQueryForm/'+id);
    }
    public updateArchDetailsByAd(archiQuery){
        return this.http.post<ResponseMessage>(this.usersUrl1 +'updateArchRemarkByAd',archiQuery);
    }
    public updateEnggDetailsByAd(engiiQuery){
        return this.http.post<ResponseMessage>(this.usersUrl1 +'updateEnggDetailsByAd',engiiQuery);
    }
    public updateHortiDetailsByAd(hortyQuery){
        return this.http.post<ResponseMessage>(this.usersUrl1 +'updateHortiDetailsByAd',hortyQuery);
    }
    public updateArchDetailsByAdArch(archiQuery){
        return this.http.post<ResponseMessage>(this.usersUrl1 +'updateArchDetailsByAdArch',archiQuery);
    }
    public updateArchDetailsByAdEngg(engiiQuery){
        return this.http.post<ResponseMessage>(this.usersUrl1 +'updateArchDetailsByAdEngg',engiiQuery);
    }
    public updateArchDetailsByAdHorti(hortyQuery){
        return this.http.post<ResponseMessage>(this.usersUrl1 +'updateArchDetailsByAdHorti',hortyQuery);
    }
    public updateByDdArch(archiQuery){
        return this.http.post<ResponseMessage>(this.usersUrl1 +'updateByDdArch',archiQuery);
    }
    public updateByeEe(engiiQuery){
        return this.http.post<ResponseMessage>(this.usersUrl1 +'updateByeEe',engiiQuery);
    }
    public updateByeDirectorArch(archiQuery){
        return this.http.post<ResponseMessage>(this.usersUrl1 +'updateByeDirectorArch',archiQuery);
    }
    public saveRWADeficiencyMemo(createMemo){
        return this.http.post<ResponseMessage>(this.usersUrl1 +'saveRWADeficiencyMemo',createMemo);
    }
    public getListRwaForm(id,roleName,deptName){
        const params = new HttpParams()
        .set('id', id)
        .set('roleName', roleName)
        .set('deptName', deptName);
        return this.http.get<Array<RWAOfficeSpaceEnt>>(this.usersUrl1 +'getListRwaForm',{params});
    }
    public saveRwaApplicantDetailsByDepatUser(data){
        return this.http.post<ResponseMessage>(this.workFlowURL +'saverwaByDepatUser',data);
    }
    public getWorkFlowStatusByAppNo(id){
        return this.http.get<any>(this.workFlowURL +'getWorkFlowStatusByAppNo/'+id);
    }
    public submitRwaDeficiencyMemo(data){
        return this.http.post<RwaDeficiencyMemoModel>(this.workFlowURL +'submintRwaDeficiencyMemo',data);  
    }
    public getRwaListDeficiencyMemoForm(id){
        return this.http.get<any>(this.usersUrl1 +'getRwaListDeficiencyMemoForm/'+id);
    }
    public updateRWAOfficeSpace(data){
        return this.http.post<RWAOfficeSpaceEnt>(this.usersUrl1 +'updateRWAOfficeSpace',data);
    }
    public getAccountDepartmentList(id){
        return this.http.get<any>(this.usersUrl1 +'getAccountDepartmentList/'+id);
    }
    public generatePdfFordemandletter(data){
        const httpOptions = {
            'responseType'  : 'arraybuffer' as 'json'
             //'responseType'  : 'blob' as 'json'        //This also worked
          };
        return this.http.post<any>(this.usersUrl1 +'generatePdfFordemandletter',data,httpOptions);
    }
    public getdemandletter(){
        return this.http.get<any>(this.usersUrl1 +'getdemandletter/');
    }
    public generatePdfForpossessionletter(data){
        const httpOptions = {
            'responseType'  : 'arraybuffer' as 'json'
             //'responseType'  : 'blob' as 'json'        //This also worked
          };
        return this.http.post<any>(this.usersUrl1 +'generatePdfForpossessionletter',data,httpOptions);
    }
    public getListRwaMyAppForm(id,roleName){
        const params = new HttpParams()
        .set('id', id)
        .set('roleName', roleName);
        return this.http.get<any>(this.usersUrl1 +'getListRwaMyAppForm',{params});
    }
    public getListRwaRegistrationForm(id,roleName){
        const params = new HttpParams()
        .set('id', id)
        .set('roleName', roleName);
        return this.http.get<RWARegistrationEnt[]>(this.usersUrl1 +'getListRwaRegistrationForm',{params});
    }
    public submitRwaWorkflowRegistration(data){
        return this.http.post<any>(this.rwaRegistrationWorkFlow +'rwaApplicationProcess',data);
    }
    public getWorkFlowStatusByAppNoRwaReg(applicationId){
        return this.http.get<any>(this.rwaRegistrationWorkFlow +'getWorkFlowStatusByAppNo/'+applicationId);
    }

    // public getDisputeAppStatus(applicationId){
    //     return this.http.get<any>(this.disputeUrl +'getDisputeAppStatus/'+applicationId);
    // }

    public saveRWARegisDeficiencyMemo(data){
        return this.http.post<any>(this.rwaRegistrationWorkFlow +'submintRwaRegisDeficiencyMemo',data);
    }
    public submitRwaDisputenDeficiencyMemo(data){
        return this.http.post<any>(this.disputeUrl +'submitRwaDisputenDeficiencyMemo',data);
    }
    public getRwaRegisListDeficiencyMemoForm(applicationId){
        return this.http.get<any>(this.usersUrl1 +'getRwaRegisListDeficiencyMemoForm/'+applicationId);
    }
    public getListRwaRegistrationPublishForm(){
        return this.http.get<any>(this.usersUrl1 +'getListRwaRegistrationPublishForm/');
    }
    public getListRwaRegistrationUnpublishForm(userId){
        return this.http.get<any>(this.usersUrl1 +'getListRwaRegistrationUnpublishForm/'+userId);
    }
    public updateRwaRegistration(data){
        return this.http.post<any>(this.usersUrl1 +'updateRwaRegistration/',data);
    }
    public getListRWARegistration(applicationId){
        return this.http.get<Array<RWARegistrationEnt>>(this.usersUrl1 +'listRWARegistration/'+applicationId);
    }
    public submitRWAObjectioner(data){
        return this.http.post<ResponseMessage>(this.rwaRegistrationWorkFlow +'submitRWAObjectioner/',data);
    }
    public numberOfApplication(data){
        return this.http.post<any>(this.rwaRegistrationWorkFlow +'numberOfApplication/',data);
    }

    public getRwaRegisteredListByDate(data){
        return this.http.post<any>(this.rwaRegistrationWorkFlow +'getRwaRegisteredListByDate/',data);
    }

  
    public numberOfDisputeApp(data){
       // alert("this searching date services?????????");
        return this.http.post<any>(this.rwaRegistrationWorkFlow +'numberOfDisputeApp/',data);
    }
    
    public getRwaObjectionList(applicationId){
        return this.http.get<ObjectionerRwaRegisModel>(this.usersUrl1 +'getRwaObjectionList/'+applicationId);
    }
    public updateRwaObjectionList(data){
        return this.http.post<any>(this.usersUrl1 +'updateRwaObjectioner/',data);
    }
    public saveMeetingScheduleDetails(data){
        return this.http.post<ResponseMessage>(this.usersUrl1 +'saveMeetingSchedule/',data);
    }
    public getRwaMeetingSchedule(data){
        return this.http.post<RWAMeetingScheduleModel[]>(this.usersUrl1 +'getRwaMeetingSchedule/',data);
    }
    public generatePdfForRecognLetter(data){
        alert("sdfsfsd");
        const httpOptions = {
            'responseType'  : 'arraybuffer' as 'json'
          };
        return this.http.post<any>(this.usersUrl1 +'generateRecognitionLetter',data,httpOptions);
    }
    public getRWARegistrationDetails(id){
        return this.http.get<RWARegistrationEnt>(this.usersUrl1 +'getRWARegistrationDetails/'+id);
    }

    public getListRwaRegistrationForDispute(id){
        return this.http.get<any>(this.usersUrl1 +'getListRwaRegistrationForDispute/'+id);
    }

    public dateFilterOnPublishForm(data){
        return this.http.post<any>(this.usersUrl1 +'dateFilterOnPublishForm/',data);
    }
    public submitRwaDispute(data){
        return this.http.post<ResponseMessage>(this.rwaDespute +'submitRwaDispute/',data);
    }
    public getRWARegistrationApprovedList(){
        return this.http.get<Array<RWARegistrationEnt>>(this.usersUrl1 +'getRWARegistrationApprovedList/');
    }
    public objectionerApplicationStatus(applicationNo,objectionerId){
        return this.http.get<any>(this.rwaRegistrationWorkFlow +'objectionerApplicationStatus/'+ applicationNo + "/" + objectionerId);
    }
    public getRwaRegisListForObjetion(id,reasonToRegister){
        return this.http.get<Array<RWARegistrationEnt>>(this.usersUrl1 +'getRwaRegisListForObjetion/'+id+"/"+reasonToRegister);
    }
    public getOjectionerListById(id){
        return this.http.get<Array<RWARegistrationEnt>>(this.usersUrl1 +'getOjectionerListById/'+id);
    }
    public getDisputeAppStatus(id){
        return this.http.get<any>(this.disputeUrl +'getDisputeAppStatus/'+id);
    }
2
    public getListRwaDisputeForm(id,roleName){
        const params = new HttpParams()
        .set('id', id)
        .set('roleName', roleName);
        return this.http.get<any>(this.usersUrl1 +'getListRwaDisputeForm',{params});
    }

    public getListRwaDisputeDetails(id){
        return this.http.get<any>(this.usersUrl1 +'getListRwaDisputeDetails/'+id);
    }

    // public submitRwaWorkflowDispute(rwaRegistration){
    //     return this.http.post<ResponseMessage>(this.disputeUrl +'submitRwaWorkflowDispute',rwaRegistration);
    // }

    public submitRwaWorkflowDispute(data){
        return this.http.post<any>(this.disputeUrl +'submitRwaWorkflowDispute',data);
    }
   // this.rwaService.submitRwaWorkflowDispute(this.rwaRegistration).subscribe(data=>{
    public getRwaDisputeListDeficiencyMemoForm(id){
        return this.http.get<any>(this.disputeUrl +'getRwaDisputeDMemo/'+id);
    } 

    public getRWADisputeDetails(id){
        return this.http.get<any>(this.usersUrl1 +'getRWADisputeDetails/'+id);
    }

    public updateRwaDispute(data){
        return this.http.post<any>(this.disputeUrl +'updateRwaDispute',data);
    }  
    
    public saveDisputeMeetingDetails(data){
        return this.http.post<ResponseMessage>(this.disputeUrl +'saveDisputeMeetingDetails/',data);
    }

    public getRWAMaintenanceDetails(id){
        return this.http.get<any>(this.usersUrl1 +'getRWAMaintenanceDetails/'+id);
    }

    public getListRWAMaintenanceForm(id,roleName){
        const params = new HttpParams()
        .set('id', id)
        .set('roleName', roleName);
        return this.http.get<any>(this.rwaMaintenanceWf +'getListRWAMaintenanceForm/',{params});
    }

    public submitMaintenanceDeficiencyMemo(data){
        return this.http.post<any>(this.rwaMaintenanceWf +'submitMaintenanceDeficiencyMemo',data);
    }

    public submitTaskToWorkFlow(data){
        return this.http.post<any>(this.rwaMaintenanceWf +'submitTaskToWorkFlow',data);
    }


    public updateRWAMaintenance(data){
    console.log(data);
        return this.http.post<any>(this.usersUrl1 +'updateRWAMaintenance',data);
    } 
    
    public getApplicationStatus(applicationId){
        return this.http.get<any>(this.rwaMaintenanceWf +'getWorkFlowStatusByAppNo/'+applicationId);
    }

    public getRwaMaintenanceDeficiencyMemo(id){
        return this.http.get<any>(this.rwaMaintenanceWf +'getRwaMaintenanceDeficiencyMemo/'+id);
    }
    
    public getRwaMaintenanceListByDate(data){
        return this.http.post<any>(this.rwaMaintenanceWf +'getRwaMaintenanceListByDate/',data);
    }
    public generatePdfForpossessionSlip(data){
        const httpOptions = {
            'responseType'  : 'arraybuffer' as 'json'
          };
        return this.http.post<any>(this.usersUrl1 +'generatePdfForpossessionSlip/',data,httpOptions);
    }
    public generatePdfForOpenSpaceOffice(data){
        const httpOptions = {
            'responseType'  : 'arraybuffer' as 'json'
          };
        return this.http.post<any>(this.usersUrl1 +'generatePdfForOpenSpaceOffice',data,httpOptions);
    }
    public generatePdfForExistingStructureOffice(data){
        const httpOptions = {
            'responseType'  : 'arraybuffer' as 'json'
          };
        return this.http.post<any>(this.usersUrl1 +'generatePdfForExistingStructureOffice',data,httpOptions);
    }
    public getEnggJEList(data){
        return this.http.post<any>(this.usersUrl1 +'getEnggJEList/',data);
    }
    public getArechitectureList(data){
        return this.http.post<any>(this.usersUrl1 +'getArechitectureList/',data);
    }
    public getHorticultureList(data){
        return this.http.post<any>(this.usersUrl1 +'getHorticultureList/',data);
    }
    public getAccountList(data){
        return this.http.post<any>(this.usersUrl1 +'getAccountList/',data);
    }
}  

